<template>
  <div class="caixa-respondentes">
    <fieldset>
      <legend>Servidores já avaliados neste formulário:</legend>
      <div v-for="respondente in respondentes" :key="respondente.lotacao_id" class="respondente-item">
        <p class="dado-texto">
          Nome: <span>{{ respondente.nome }}</span>
        </p>
        <p class="dado-texto">
          CPF: <span>{{ formatarCPF(respondente.cpf) }}</span>
        </p>
        
      <div class="acoes">
        <img @click="abrirModal(respondente)" src="../../assets/imagens/icon-view.svg" alt="Visualizar Respostas" title="Visualizar Respostas" class="icone-acao">

        <!-- A API só libera para quem avaliou e com o formulário aberto -->
        <router-link
          v-if="respondente.pode_editar"
          :to="{ name: 'FormularioResponder', params: { id: formularioId }, query: { avaliado_id: respondente.id } }"
          title="Editar Respostas"
        >
          <img src="../../assets/imagens/linhas-caneta-escuro.svg" alt="Editar Respostas" class="icone-acao">
        </router-link>
      </div>
      </div>
    </fieldset>

    <VisualizarRespostasModal
      v-if="modalVisivel"
      :servidor="servidorSelecionado"
      :formulario-id="formularioId"
      @close="fecharModal"
    />
  </div>
</template>

<script>
// 1. Importe o novo componente do modal
import VisualizarRespostasModal from './VisualizarRespostasModal.vue';

export default {
  name: "ListaRespondentes",
  // 2. Registre o novo componente
  components: { VisualizarRespostasModal },
  props: {
    respondentes: { type: Array, required: true },
    formularioId: { type: [String, Number], required: true },
  },
  // 3. Adicione as variáveis para controlar o modal
  data() {
    return {
      modalVisivel: false,
      servidorSelecionado: null,
    };
  },
  methods: {
    formatarCPF(cpf) {
      if (!cpf) return '';
      const cpfLimpo = cpf.replace(/\D/g, '');
      return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },
    // 4. Adicione os métodos para abrir e fechar o modal
    abrirModal(respondente) {
      this.servidorSelecionado = respondente;
      this.modalVisivel = true;
    },
    fecharModal() {
      this.modalVisivel = false;
      this.servidorSelecionado = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Seu CSS que já estava funcionando... */
.caixa-respondentes { background-color: #f5f5f5; border: 3px solid #568055; border-radius: 8px; padding: 1.5rem; width: 50%; margin: 0 auto 2rem auto; min-width: 400px; box-shadow: #005516 0px 5px 15px; }
fieldset { border: none; padding: 0; margin: 0; }
legend { font-family: "Montserrat-Bold"; font-size: 1.2rem; font-weight: bold; color: #333; margin-bottom: 1rem; padding-bottom: 0.5rem; border-bottom: 2px solid #005516; width: 100%; text-align: center; }
.respondente-item { display: grid; grid-template-columns: 1fr 1fr auto; gap: 1rem; align-items: center; background-color: #fff; border: 1px solid #eee; border-radius: 4px; margin-bottom: 1rem; padding: 0.5rem 1rem; }
.dado-texto { font-family: "Montserrat-Medium"; font-size: 1.1rem; font-weight: bold; margin: 0; }
.dado-texto span { font-weight: normal; }
.acoes {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.icone-acao { height: 1.5rem; width: 1.5rem; cursor: pointer; }
.icone-acao:hover { opacity: 0.7; }
</style>